export function CanSendFeedback() {
	return true;
}

export function FeedbackSubmissionTemplate() {
	return 'feedbackSubmission';
}

export function ContactUsRequestTemplate() {
	return 'contactUsRequest';
}
